module.exports = __webpack_public_path__ + "static/media/extrait_validation_gamma.93d43dbc.pdf";